<template>
  <div class="" v-if="broker != null">
    <div class="text-base text-center">
      Add your very own video
    </div>

    <div class="mt-1 text-sm text-gray-700 text-center">
      When your client logs in to fill out the form, you can present them with
      your very own welcome video, making it a powerful way to engage your client.
      Below is a default video we created for all of our brokers which you can use.
    </div>

    <div class="mt-6 bg-gray-200 px-3 p-4 rounded-lg">
      <template v-if="broker.video != null && broker.video != ''">
        <template v-if="getYoutubeVideoId(broker.video) == null">
          <div class="text-center p-8 bg-gray-200 rounded">
            <img src="https://img.icons8.com/dusk/64/000000/no-video.png" class="inline" />
            <div class="mt-2 text-sm text-gray-800">
              Invalid YouTube link. Please copy &amp; paste full YouTube video URL.
            </div>
          </div>
        </template>

        <template v-else>
          <iframe
            style="width:100%;height:300px;"
            :src="'https://www.youtube.com/embed/' + getYoutubeVideoId(broker.video)"
            frameborder="0"
            allowfullscreen></iframe>
        </template>
      </template>

      <template v-else>
        <iframe 
          style="width:100%;height:300px;"
          src="https://www.youtube.com/embed/o1MFPCF-bcs"
          frameborder="0"
          allowfullscreen></iframe>
      </template>
    </div>

    <div class="mt-4 text-sm text-gray-700 text-center">
      If you don't have your own video, you can always add it later. If you have one, 
      you can add it below. Please note that we currently accept only YouTube videos.
    </div>

    <div class="mt-2">
      <input type="text" class="input-standard" v-model="broker.video" placeholder="Copy and paste your YouTube video URL here" />
    </div>

    <div class="text-center mt-20 flex items-center justify-center">
      <div class="inline-block bg-green-600 w-3 h-3 rounded-full"></div>
      <div class="inline-block bg-gray-200 w-12 mx-2" style="height:2px;"></div>
      <div class="inline-block bg-green-600 w-3 h-3 rounded-full"></div>
      <div class="inline-block bg-gray-200 w-12 mx-2" style="height:2px;"></div>
      <div class="inline-block bg-green-600 w-3 h-3 rounded-full"></div>
      <div class="inline-block bg-gray-200 w-12 mx-2" style="height:2px;"></div>
      <div class="inline-block bg-green-600 w-3 h-3 rounded-full"></div>
    </div>

    <div class="mt-4 text-xs">
      <table class="w-full">
        <tr>
          <td class="w-1/3">
            <router-link 
              :to="{
                name  : 'broker-onboard-personalize-three',
                params: {
                  brokerId   : $route.params.brokerId
                }
              }"
              tag="a" 
              class="rounded px-4 py-2 text-xs bg-gray-500 hover:bg-gray-600 text-white float-left">
              <svg width="16" height="16" stroke-width="2" class="float-left" style="margin-top:1px;" stroke="currentColor" fill="none">
                <use xlink:href="/static/img/feather-sprite.svg#chevron-left"/>
              </svg>
              Back
            </router-link>
          </td>
          <td class="w-1/3">
            <div class="text-gray-600 text-center">Step 4 of 4</div>
          </td>
          <td class="w-1/3">
            <button
              @click.prevent="next()"
              :class="{ 
                'rounded px-4 py-2 text-xs float-right'    : true,
                'bg-blue-500 hover:bg-blue-600 text-white' : broker.video != null && broker.video.length > 0,
                'bg-gray-500 hover:bg-gray-600 text-white' : broker.video == null || broker.video.length == 0
              }">

              <span class="float-left">Next</span>

              <svg width="16" height="16" stroke-width="2" class="float-left" style="margin-top:1px;" stroke="currentColor" fill="none">
                <use xlink:href="/static/img/feather-sprite.svg#chevron-right"/>
              </svg>
            </button>
          </td>
        </tr>
      </table>
    </div>
  </div>
</template>

<script>
  import { EventBus }   from '@/shared/event-bus'
  import PageHeader     from '@/shared/components/headers/PageHeader'
  import SubmitButton2  from '@/shared/components/form/SubmitButton2'
  import { Sketch }     from 'vue-color'
  
  export default {

    components: {
      PageHeader,
      SubmitButton2,
      'sketch-picker': Sketch,
    },

    data () {
      return {
        loading: false,
        broker : null,
      }
    },

    created() {
      this.getBroker({
        brokerId: this.$route.params.brokerId
      }, (broker) => {
        this.broker = broker
        this.broker.header_text = this.broker.header_text == null ? '0' : this.broker.header_text
      })
    },

    computed : {
      backgroundColor : {
        get() {
          return this.broker.header_background
        },

        set(value) {
          this.broker.header_background = value.hex
        }
      },

      textColor() {
        return this.broker.header_text == 0 ? '#fff' : '#000'
      }
    },

    methods : {
      uploadFile($event, fileType) {
        let file     = $event.target.files[0] || $event.dataTransfer.files[0]
        let formData = new FormData()
        formData.append('file', file)
        formData.append('fileType', fileType)
        formData.append('brokerId', this.broker.id)
        this.showLoader("Uploading...")

        axios.post(process.env.VUE_APP_API_URL + '/api/broker/upload', formData, {
          headers: {
            'Content-Type'  : 'multipart/form-data',
            'Authorization' : 'Bearer ' + localStorage.getItem('bp-broker-jwt')
          }
        }).then(response => {
          this.hideLoader()
          this.getCurrentBroker()
        }).catch(function(err) {
          this.hideLoader()
        });
      },

      next() {
        if(this.broker.video != null) {
          this.apiPost({
            brokerId: this.broker.id,
            values  : {
              video: this.broker.video
            }
          }, 'broker/save', () => {
            this.$router.push({
              name  : 'broker-onboard-personalize-done',
              params: {
                brokerId : this.broker.id
              }
            })
          })
        }

        else {
          this.$modal.show('confirm-modal', {
            // width : 600,
            title  : "Are you sure?",
            message: "Are you sure you want to proceed without uploading a video?",
            buttons:[{
              label          : 'Yes',
              color          : 'green',
              loadingViaLocal: true, // a bit of HACK, we want to show loading image when button is clicked, but hard to pass loading prop to a modal
              action         : () => {
                this.$modal.hide('confirm-modal')
                this.$router.push({
                  name  : 'broker-onboard-personalize-done',
                  params: {
                    brokerId : this.broker.id
                  }
                })
              }
            }, {
              label : 'No',
              color : 'gray',
              action: () => {
                this.$modal.hide('confirm-modal')
              }
            }]
          })
        }
      }
    },
  }
</script>